import CryptoJS from "crypto-js";
import { AES_SECRET } from "./config.js";

// The login API expects the password AES-encrypted in CryptoJS's
// "U2FsdGVkX1..." (OpenSSL salted) format — NOT the bare password.
//
// The real frontend (dashboard.tangoeye.ai) encrypts the string
//   `${password}___${unixSeconds}`
// where unixSeconds is the current Unix time in seconds. The "___<timestamp>"
// suffix is a freshness nonce the backend strips before comparing. We must
// reproduce this exactly or the backend rejects the credentials.
export function encryptPassword(plaintext) {
  const unixSeconds = Math.floor(Date.now() / 1000);
  const payload = `${plaintext}___${unixSeconds}`;
  return CryptoJS.AES.encrypt(payload, AES_SECRET).toString();
}
